import React from "react";
import {Navbar as BootstrapNavbar, Nav, Container} from "react-bootstrap";
import {Link} from "react-router-dom";
import Logo from "./logo.svg";
import {useAuth0} from "@auth0/auth0-react";
import Button from "../Button";

const Navbar = (): JSX.Element => {
    const {isAuthenticated, logout, user} = useAuth0();

    const handleOnClick = (): void => {
        logout();
    }

    return (
        <BootstrapNavbar bg="dark" variant="dark" sticky="top">
            <Container>
                <BootstrapNavbar.Brand>
                    <Link className="navbar-brand" to="/">
                        <img
                            alt=""
                            src={Logo}
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                        />
                    </Link>
                </BootstrapNavbar.Brand>
                <Nav className="me-auto">
                    <Link className="nav-link" to="/posts">Posts</Link>
                    <Link className="nav-link" to="/movies">Movies</Link>
                </Nav>
                {
                    isAuthenticated &&
                    <Nav>
                        <BootstrapNavbar.Text className="mx-2">Signed in as: {user?.nickname}</BootstrapNavbar.Text>
                        <Button type="button" variant="light" size="sm" onClick={handleOnClick}>Logout</Button>
                    </Nav>
                }

            </Container>
        </BootstrapNavbar>
    );
};

export default Navbar;